module.exports = __webpack_public_path__ + "img/potassio.6f68bbd6.png";